<template>
    <form-container header="Kategoriler" v-on:save="save" :disabled="loading">
        <div class="row">
            <div class="col col-limit">
                <div class="form-group">
                    <label>{{translate('category.categoryName')}}</label>
                    <input @input="checkInput('Name',$event)" v-model="data.Name" type="text" class="form-control" required />
                </div>
                <div class="form-group">
                    <label>{{translate('category.documentType')}}</label>
                    <select class="form-control" v-model="data.Type">
                        <option v-for="(obj, i) in $izonay.documentTypes" :key="i" :value="i">{{obj.text}}</option>
                    </select>
                    <small class="text-muted">{{translate('category.documentTypeText')}}</small>
                </div>
                <div class="form-group">
                    <label>
                        <input type="checkbox" v-model="data.IsActive" />
                        {{translate('category.categoryActive')}}
                    </label>
                </div>
                <div class="form-group">
                    <label>
                        <input type="checkbox" v-model="data.IsViewable" />
                        {{translate('category.visible')}}
                    </label>
                </div>

                <div class="form-group">
                    <label>
                        <input type="checkbox" v-model="data.Params.EncryptedFileUpload" />
                        {{translate('category.encryptedFileUpload')}}
                    </label>
                </div>

                <div class="form-group form-check">
                        <input type="checkbox" class="form-check-input" v-model="data.Params.IsMinSignerCountActive" id="MinSignerCountActive">
                        <label for="MinSignerCountActive" class="form-check-label">
                            {{translate('accountParams.toCirculateJob')}} <input v-model="data.Params.MinSignerCount" min="1" :disabled="!data.Params.IsMinSignerCountActive" required class="line-input" style="width:50px; text-align:center;" type="number"/> {{translate('accountParams.shouldBeSigner')}} 
                        </label>
                    </div>
            </div>
        </div>
        <template v-slot:footer>
            <div class="row">
                <div class="col"> 
                    <div class="row">
                        <div class="col">
                            <button type="button" accesskey="g" v-on:click="goBack" class="btn btn-outline-primary">{{translate('goBack')}}</button>
                        </div>
                        <div class="col text-right">
                            <button type="submit" accesskey="k" class="btn btn-success">{{translate('save')}}</button>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </form-container>
    
</template>

<script>
import formMixin from '../formMixin.js';
import formContainer from '../components/FormContainer.vue'


export default {
    mixins: [formMixin],
    components: {
        formContainer,
    },
    
    created(){
        this.getData(this.$route.params.id, true, this.$route.query.kind);
    },
    methods: {
        checkInput(value, event) {
            // Check for invalid characters
            if (/[<>]/.test(event.target.value)) {
                alert(this.translate('errors.invalidSymbols'))
                const editedText = ""
                this.$set(this.data, value, editedText)
            } else {
                this.$set(this.data, value, event.target.value)
            }
        },
    },
    data() {
        return {
            loading: false,
            modelName: 'Category',
            data: {
                Params: {}
            },
        }
    },
}
</script>